module.exports = __webpack_public_path__ + "static/img/bonus_5.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_5.png
// module id = u1Xn
// module chunks = 0